jQuery(document).ready(function($){
   jQuery(document.body).on('click', '#rdmore', function(e){
    e.preventDefault(); var t = jQuery(this);
    jQuery('.colspe_box').toggleClass('active');
    t.text((t.text() == 'Read less') ? 'Read More' : 'Read less').fadeIn();
  });
   var body = $('body'),
        doc = $(document),
        html = $('html'),
        win = $(window);
   var wishListsArr = localStorage.getItem('items') ? JSON.parse(localStorage.getItem('items')) : [];
    var compareArr = localStorage.getItem('compareArr') ? JSON.parse(localStorage.getItem('compareArr')) : [];

    localStorage.setItem('items', JSON.stringify(wishListsArr));
    if (wishListsArr.length) {
        wishListsArr = JSON.parse(localStorage.getItem('items'));
    };
   
  var belps = {
    init: function(){
      this.main_menu_fixed();
      this.mobile_menu();
      this.mobile_tabs();
      this.getItems();
      this.wishlist();
      this.wishlisticons();
      this.ajax_pagination();
      this.set_page_items();
      this.removeitems();
    },
    main_menu_fixed: function(){
       $(window).scroll(function() {
    		scroll = $(window).scrollTop();
    		var e = $(".px_header");
    		scroll >= 210 ? e.addClass("fixed") : e.removeClass("fixed");
    	});
      $('.col-auto.sidecart .cart-icon').on('mouseover', function(){
        $('#mini_cart').slideDown();
      });
       $(document).mouseup(function(e){
        var mini_cart = $('#mini_cart');
  
        // If the target of the click isn't the container
        if(  mini_cart.has(e.target).length === 0){
          mini_cart.slideUp();
        }
      });
    },
    mobile_menu: function(){
      $('li.submenu a.alink').on('click', function(e){
        e.preventDefault();
        var t = $(this); t.parent().toggleClass('open_dropdown'); t.parent().find('ul').slideToggle();
        t.parent().siblings().removeClass('open_dropdown');t.parent().siblings().find('ul').slideUp();
      });
      $('.site_footer .ft-widget h3.toggle_menu').on('click', function(){
        var t = $(this); t.parent().toggleClass('active'); t.next().slideToggle();
      });
    },
    mobile_tabs: function(){
      $('a[href="#pxaccount"]').on('click', function(e){
        e.preventDefault();
    		$('[data-user-mobile-toggle]').trigger('click');
      });
      $('a[href="#home"]').on('click', function(e){
        e.preventDefault();
        $('html, body').animate({
          scrollTop: jQuery("#shopify-section-header").offset().top
        }, 1000); 
         $('.px_search_bar input[type="search"]').focus();
      });
      $('a[href="#search"]').on('click', function(e){
        e.preventDefault();
      	$('.px_search_bar').slideToggle();
         $('.px_search_bar input[type="search"]').focus();
      });
    },
    getItems: function(){
      $.getJSON("/cart.json", function(e) {
		var total_cart_price = Shopify.formatMoney(e.original_total_price);
		$("[data-cartcount],[data-cart-count]").text(e.item_count);
        if( e.item_count == 0 ){
          $('.no-item-cart').show();
          $('form.cart-form.wrapper-template-cart').hide();
        }else{
          $('.no-item-cart').hide();
          $('form.cart-form.wrapper-template-cart').show();
        }
        if( e.item_count > 1 ){
          $('[data-cartabre]').text('are');
        }else{
          $('[data-cartabre]').text('is');
        }
        $("#sidecart_total,#px-sidecart .total .price, .template-cart .cart_page .grouped-bottom .total span.price, .template-cart .cart_page .right-col .total span.price").html(Shopify.formatMoney(e.original_total_price));
        $("#mc-limit").html('CHECKOUT '+Shopify.formatMoney(e.original_total_price));
        for (let i = 0; i < e.items.length; i++) {
          jQuery('#btn-func-'+e.items[i].id).addClass('active');
          jQuery('#btn-func-'+e.items[i].id).find('input').val(e.items[i].quantity);
          jQuery('[data-item-id="'+e.items[i].id+'"] span.price').text(Shopify.formatMoney(e.items[i].original_line_price));
        }
        if( e.items.length == 0 ){
          $('.no-items').show();
          $('#px-sidecart').removeClass('sidebar_active');
        }else{
          $('.no-items').hide();
          $('#px-sidecart').addClass('sidebar_active');
        }
        $('[data-toggle="tooltip"]').tooltip();
            if( $('li[data-item-id="41749242970287"]').is(":visible") == true ){
              $('#edchrgs, #cold_shipper').hide();
              var pr = $('.template-cart .cart_page .grouped-bottom .total span.price').html();
              var pri = pr.replace('C$', '');
              var coldchrg = "6.99";
              var price = parseFloat(coldchrg) + parseFloat(pri);
              $('.template-cart .cart_page .grouped-bottom .total span.price').html('C$'+price.toFixed(2));
            }
      });
      $.get('/cart?view=sidecart', function (cartitems) {
        $('#cart-item_list').html(cartitems);
      }); 
      var sortby = $('a.dropdown-item.cactive').text();
      $('#tabletxt').text(sortby);
    },
    wishlist:function(ProductHandle){
      var wishlistElm = $('[data-product-handle="'+ ProductHandle +'"]'),
            idxArr = wishListsArr.indexOf(ProductHandle);
        $('#WishCounter').text(wishListsArr.length);
        if(idxArr >= 0) {
            wishlistElm.addClass('whislist-added');
                wishlistElm.find('.wishlist-text').text('window.inventory_text.remove_wishlist'); 
        }
        else {
            wishlistElm.removeClass('whislist-added');
                wishlistElm.find('.wishlist-text').text('window.inventory_text.add_wishlist');
        };
      var iconWishListsSlt = '[data-icon-wishlist]';

            doc.off('click.addOrRemoveWishlist', iconWishListsSlt).on('click.addOrRemoveWishlist', iconWishListsSlt, function(e) {
                e.preventDefault();

                var self = $(this),
                    productId = self.data('id'),
                    ProductHandle = self.data('product-handle'),
                    idxArr = wishListsArr.indexOf(ProductHandle);

                if(!self.hasClass('whislist-added')) {
                    self.addClass('whislist-added');
                        self.find('.wishlist-text').text('window.inventory_text.remove_wishlist');

                    if($('[data-wishlist-container]').length) {
                        ella.createWishListTplItem(ProductHandle);
                    };

                    wishListsArr.push(ProductHandle);
                    localStorage.setItem('items', JSON.stringify(wishListsArr));
                } else {
                    self.removeClass('whislist-added');
                    $('[data-wishlist-added="wishlist-'+productId+'"]').remove();

                    wishListsArr.splice(idxArr, 1);
                    localStorage.setItem('items', JSON.stringify(wishListsArr));

                    if($('[data-wishlist-container]').length) {
                      
                    };
                };

                belps.wishlist(ProductHandle);
            });
    },
    wishlisticons: function() {
        var wishListItems = JSON.parse(localStorage.getItem('items'));
      // var listitem = wishListItems.split(",");
        for (var i = 0; i < wishListItems.length; i++) {
            var icon = $('[data-product-handle="'+ wishListItems[i] +'"]');
            icon.addClass('whislist-added');
          $.get('/products/' + wishListItems[i] + '?view=wishlist', function (quick_response) {
            $('#px_wishlist').append(quick_response);
          }); 
        }
    },
    ajax_pagination: function(){ var count = 1;
      $(document.body).on('click', '.px-infinite-scrolling a', function(e){
        count++; e.preventDefault();
        $(this).append(' <div class="spinner-border spinner-border-sm"></div>');
        $.ajax({
            type: "get",
            url: $(this).data('href'),
            beforeSend: function () {
            },
            success: function (data) {
              var result = $(data).find('.product-collection.fav_products ul, .blog_list ul').html();
              var filterform = $(data).find('.filter-form').html();
              var pagebtn = $(data).find('.px-infinite-scrolling').html();
              $('.px-infinite-scrolling').html(pagebtn);
              $('.product-collection.fav_products ul, .blog_list ul').append(result);
              $('#filter-form').html(filterform); 
              $(".js-range-slider").ionRangeSlider({
                 onChange: function(rp){
                   $('input[name="filter.v.price.gte"]').val(rp.from);
                       $('input[name="filter.v.price.lte"]').val(rp.to);
                 },
                onFinish: function(){
                  $('#filter-form').append('<input type="hidden" name="sort_by" value="price-ascending" />');
                  $('#filter-form').submit();
                }
              });
              $('.loading-modal').hide();
              $("div.col-sidebar .filter-group ul li").slice(0, 10).show();
              $("div.col-sidebar .filter-groups ul li").slice(0, 10).show();
              $("ul#filtter-health-ingredients li").slice(0, 10).show();
              $("ul#filtter-brand li").slice(0, 10).show();
            }, 
            error: function (xhr, text) {},
            complete: function () {
              var st = $('#filter-form'),
               sf = st.serialize(); 
              window.history.pushState('page2', 'Title', '?'+sf);
            }
        });
      });
    },
    set_page_items: function(){
      $(document.body).on('click', '[data-setitemnumber] a',function(e){
       e.preventDefault();  
        var v = $(this).data('pnumber');
        $.ajax({
            type: "Post",
            url: '/cart.js',
            data: {
                "attributes[pagination]": v
            },
            success: function (data) {
                window.location.reload();
            },
            error: function (xhr, text) {
 
            },
            dataType: 'json'
        });
     });
      
    },
    removeitems: function(){
      $(document.body).on('click','#remove-item', function(){
        var t = $(this);
        var id = t.data('id');
        $.ajax({
            type: "post",
            url: "/cart/change.js",
            data: 'quantity=0&id=' + id,
            dataType: 'json',
            success: function(cart) {
              jQuery('#btn-func-'+id).removeClass('active');
              jQuery('#btn-func-'+id).find('input').val(1);
              jQuery('[data-product-id="'+id+'"],[data-item-id="'+id+'"]').remove();
              belps.getItems(); 
              
            },
            error: function(xhr) {          
                 
            }
        });
      });
    },
  };
  belps.init();
    var w = window.innerWidth;
   $(document.body).on('submit', '#add-to-cart-form',function (e) {
     e.preventDefault();
      var t = $(this);
     var data = t.serialize();
      
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json',
        success: function () {
          //         t.parent().removeClass('loading');
          belps.getItems();
        }
      });
    });
   
    $('.pc_product_sorting span.sorting').on('click', function(){
      $('#pc_sidebar').addClass('active');
    });
  
  $(document.body).on('change', '.qty-group input[name="updates[]"]', function(e){ 
        e.preventDefault();
        var t = $(this),
         q = t.val(),
         max_q = t.data('max'),
         productId = t.data('id');
        if( q < max_q || q == max_q ){
            $.ajax({
                type: "post",
                url: "/cart/change.js",
                data: 'quantity='+q+'&id=' + productId,
                dataType: 'json',
                success: function(cart) {
                   belps.getItems();
                },
                error: function(xhr) {}
            });
        }
        if( q > max_q ){
        	$('[data-lmtqty="'+productId+'"]').html('<div class="limited_qty"><i class="fa fa-info-circle"></i> Maximum quantity '+ max_q+'</div>');
          setTimeout(function(){ $('[data-lmtqty="'+productId+'"]').html('') }, 1500 );
        }
      });
  $(document.body).on('click', '[data-plusqttpx]', function(e){
        e.preventDefault();
        var t = $(this),
         qty = t.siblings('input[type="number"]'),
         max_q = qty.data('max'),
         form_id = qty.data('form-id'),
         productId = t.data('id'),
         q = parseInt(qty.val())+1;
        if( q < max_q || q == max_q ){
          qty.val(q);
            $.ajax({
                type: "post",
                url: "/cart/change.js",
                data: 'quantity='+q+'&id=' + productId,
                dataType: 'json',
                success: function(cart) {
                   belps.getItems();
                },
                error: function(xhr) {}
            });
        }
        if( q > max_q ){
        	$('[data-lmtqty="'+productId+'"]').html('<div class="limited_qty"><i class="fa fa-info-circle"></i> Maximum quantity '+ max_q+'</div>');
          setTimeout(function(){ $('[data-lmtqty="'+productId+'"]').html('') }, 1500 );
        }
      });
  $(document.body).on('click', '[data-minusqttpx]', function(e){
        e.preventDefault();
        var t = $(this);
        let qty = t.siblings('input[type="number"]');
        let minus = parseInt(qty.val())-1;
        let productId = t.data('id');
        if( minus > 0 ){
          qty.val(minus);
          $.ajax({
              type: "post",
              url: "/cart/change.js",
              data: 'quantity='+minus+'&id=' + productId,
              dataType: 'json',
              success: function(cart) {
                 belps.getItems();
              },
              error: function(xhr) {}
          });
        }
      })
  jQuery(document.body).on('click', '#mobile_filter_btn', function(){
    jQuery('html').addClass('sidebar-open');
  });
  jQuery("#testimonials").slick({
    arrows:false,
    dots:false
  });
  jQuery("#main-slider").slick({
    arrows:true,
    dots:false,
    prevArrow: '<span class="prevarrow"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 246.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"/></svg></span>',
    nextArrow: '<span class="nextarrow"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z"/></svg></span>'
  });
  
    $('a[href="#readmore"]').on('click', function(e){
      e.preventDefault();
      $('html, body').animate({
          scrollTop: jQuery("#pxheader_content").offset().top
      }, 700); 
    });
   $('#home_cates').slick({
      dots: false,
      infinite: true,
      arrows:false,
     autoplay:true,
      speed: 300,
      slidesToShow: 5,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1224,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
          }
        }
        
      ] 
    });
})